import { useEffect } from "react";
import { SignedOut, useUser } from "@clerk/clerk-react";
import { LoggedInInfoMessage, SelectedCitation } from "./citation";
import { analytics } from "..";
const successMessage = "User is signed in";
const url = window.location.href;

export function isRunningInBrowser() {
  return Office.context.platform === Office.PlatformType.OfficeOnline;
}

const LoggedOutInfoMessage = () => {
  useEffect(() => {
    console.log("isRunningInBrowser() ", isRunningInBrowser());
  }, []);

  return (
    <div className="flex flex-col items-center w-full px-5 pt-10">
      {isRunningInBrowser() ? (
        <LoggedInInfoMessage />
      ) : (
        <div>
          Please log in to highlight citations in your text.
          <br />
          You can chat with citations, as well as view their citing sources.
        </div>
      )}
    </div>
  );
};

const App = () => {
  const { isSignedIn, user } = useUser();

  useEffect(() => {
    if (isSignedIn && url.includes("isDialog")) {
      Office.context.ui.messageParent(successMessage);
    }
  }, [isSignedIn]);

  useEffect(() => {
    if (isSignedIn) {
      analytics.identify(user.id, {
        email: user.primaryEmailAddress?.emailAddress ?? "",
        name: user.fullName,
      });
    }
  }, [isSignedIn]);

  return (
    <>
      {(isSignedIn || isRunningInBrowser()) && <SelectedCitation />}
      <SignedOut>{!isRunningInBrowser() && <LoggedOutInfoMessage />}</SignedOut>
    </>
  );
};

export default App;
